import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=5195a65d&scoped=true"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./EmailConfiguration.vue?vue&type=style&index=0&id=5195a65d&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5195a65d",
  null
  ,true
)

export default component.exports